import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams, Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import Select from "react-select";
import swal from "sweetalert";

import { useDispatch, useSelector } from "react-redux";
import {
  createDiseaseAction,
  updateDiseaseAction,
} from "../../../store/actions/DiseasesAction";

import Loader from "../Common/Loader";

import { getCategoriesAction } from "../../../store/actions/CategoryAction";
// import { getSymptomsAction } from "../../../store/actions/SymptomAction";
import { showErrorAlert } from "../../../services/ErrorHandlingService";
//import state from "sweetalert/typings/modules/state";

const AddDiseases = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const isEditMode = location.pathname.includes("update-diseases");
  const diseaseToEdit = location.state?.disease;

  const categories = useSelector((state) => state.categories.categories || [""]);
  // const symptomsList = useSelector((state) => state.symptoms?.symptoms || []);

  const [selectedSymptoms, setSelectedSymptoms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    dispatch(getCategoriesAction(false));
    // dispatch(getSymptomsAction());
  }, [dispatch]);

  const partnerRequiredOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];


  // State to hold the disease data
  const [disease, setDisease] = useState({
    disease_code: "",
    disease_name: "",
    category_id: "",
    disease_description: "",
    // symptom_ids: [],
    disease_causes: "",
    prescription_guidelines: "",
    treatment_plan: "",
    disease_status: "Active",
    partner_required: "",
  });

  // Initialize form with disease data if in edit mode
  useEffect(() => {
    if (isEditMode && diseaseToEdit) {
      setFetching(true);
      setErrors({});

      const selectedIds = diseaseToEdit.symptoms?.map(symptom => String(symptom.symptom_id)) || [];

      // const symptomToSelect = symptomsList
      //   .filter(symptom => selectedIds.includes(String(symptom.symptom_id)))
      //   .map(symptom => ({
      //     value: symptom.symptom_id,
      //     label: symptom.symptom_name
      //   }));


      // setSelectedSymptoms(symptomToSelect);
      setDisease({
        diseaseId: id,
        disease_code: diseaseToEdit.disease_code || "",
        disease_name: diseaseToEdit.disease_name || "",
        category_id: diseaseToEdit.category_id || "",
        disease_description: diseaseToEdit.disease_description || "",
        // symptom_ids: selectedIds,
        disease_causes: diseaseToEdit.disease_causes || "",
        prescription_guidelines: diseaseToEdit.prescription_guidelines || "",
        treatment_plan: diseaseToEdit.treatment_plan || "",
        partner_required: diseaseToEdit.partner_required || "",
        disease_status: diseaseToEdit.disease_status || "Active",
      });
      setFetching(false);
    }
  }, [isEditMode, diseaseToEdit]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDisease({
      ...disease,
      [name]: value,
    });
    clearFieldError(name);
  };

  const clearFieldError = (field) => {
    setErrors((prev) => {
      if (!prev || typeof prev !== "object") return prev;
      if (!prev[field]) return prev;
      const { [field]: _removed, ...rest } = prev;
      return rest;
    });
  };

  const handleSelectChange = (field, value) => {
    setDisease({
      ...disease,
      [field]: value,
    });
    clearFieldError(field);
  };

  const validate = () => {
    const newErrors = {};
    if (!disease.disease_name.trim()) newErrors.disease_name = "Enter Disease Name";

    if (!disease.disease_code.trim()) {
      newErrors.disease_code = "Disease Code is required";
    } else if (!/^[a-zA-Z0-9]+$/.test(disease.disease_code)) {
      newErrors.medicineCode = "Disease Code must be alphanumeric";
    }

    if (!disease.category_id) newErrors.category_id = "Select Category";

    if (!disease.disease_status) newErrors.disease_status = "Status is required";

    // if (!disease.symptom_ids || disease.symptom_ids.length === 0) {
    //   newErrors.symptom_ids = "Select at least one Symptom";
    // }

    if (!disease.disease_causes) newErrors.disease_causes = "Causes is required";

    if (!disease.prescription_guidelines) newErrors.prescription_guidelines = "Enter Prescription Guidelines";

    if (!disease.treatment_plan) newErrors.treatment_plan = "Enter Treatment plan"

    if (!disease.partner_required) {
      newErrors.partner_required = "Select Partner Required";
    }

    setErrors(newErrors);

   
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    if (!validate()) {
      setLoading(false);
      return;
    }
    try {
      const payload = {
        ...disease,
        // symptom_ids: disease.symptom_ids?.join('|') || "",
      };

      if (isEditMode) {
        dispatch(updateDiseaseAction(payload, id, navigate));
        //swal("Success!", "Disease updated successfully!", "success");
      } else {
        dispatch(createDiseaseAction(payload, navigate));
        //swal("Success!", "Disease added successfully!", "success");
      }

      navigate("/diseases");
    } catch (error) {
      console.error("Error:", error);
      showErrorAlert("Failed to save disease. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  // const symptomOptions = symptomsList.map((s) => ({
  //   value: String(s.symptom_id),   // ensure string for matching
  //   label: s.symptom_name,
  // }));

  const handleSymptomChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
    setSelectedSymptoms(selectedOptions);
    setDisease({ ...disease, symptom_ids: selectedValues });
    clearFieldError("symptom_ids");
  };
  // Options for status
  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];

  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex justify-content-end p-3">
          <Link to="/diseases">
            <Button variant="primary">Back</Button>
          </Link>
        </div>
        <div className="card">
          <div className="card-body">
            {/* <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "20px",
              }}
            >
              <Button variant="primary" onClick={() => navigate("/diseases")}>
                Back
              </Button>
            </div> */}
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Disease Code</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    name="disease_code"
                    placeholder="Enter Disease Code"
                    pattern="[a-zA-Z0-9]+"
                    value={disease.disease_code}
                    onChange={handleChange}
                  //required
                  />
                  {errors.disease_code && (
                    <div className="text-danger d-block mb-2">{errors.disease_code}</div>
                  )}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Disease Name</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    name="disease_name"
                    placeholder="Enter Disease Name"
                    value={disease.disease_name}
                    onChange={handleChange}
                  //required
                  />
                  {errors.disease_name && (
                    <div className="text-danger d-block mb-2">{errors.disease_name}</div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Category</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    name="category_id"
                    options={categories.map((c) => ({
                      value: String(c.category_id),
                      label: c.category_name,
                    }))}
                    value={categories
                      .map((c) => ({
                        value: String(c.category_id),
                        label: c.category_name,
                      }))
                      .find((c) => c.value === disease.category_id)}
                    onChange={(selectedOption) =>
                      handleSelectChange(
                        "category_id",
                        selectedOption ? selectedOption.value : ""
                      )
                    }
                    placeholder="Select Category"
                    //required
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                    isClearable
                  />
                  {errors.category_id && (
                    <div className="text-danger d-block mb-2">{errors.category_id}</div>
                  )}

                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">
                    Partner Required <span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    name="partner_required"
                    options={partnerRequiredOptions}
                    value={partnerRequiredOptions.find(
                      (opt) => opt.value === disease.partner_required
                    )}
                    onChange={(selectedOption) =>
                      handleSelectChange(
                        "partner_required",
                        selectedOption ? selectedOption.value : ""
                      )
                    }
                    placeholder="Select Partner Required"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                    isClearable
                  />

                  {errors.partner_required && (
                    <div className="text-danger d-block mb-2">
                      {errors.partner_required}
                    </div>
                  )}
                </div>
              </div>



              <div className="row">
                {/* <div className="col-xl-6 mb-3">
                  <label className="form-label">Symptoms</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    isMulti
                    name="symptom_ids"
                    options={symptomOptions}
                    value={selectedSymptoms}
                    onChange={handleSymptomChange}
                    placeholder="Select Symptoms"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#e0e0e0",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                    }}
                  />
                  {errors.symptom_ids && (
                    <div className="text-danger d-block mb-2">{errors.symptom_ids}</div>
                  )}

                </div> */}
                 <div className="col-xl-6 mb-3">
                  <label className="form-label">Status</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    name="disease_status"
                    options={statusOptions}
                    value={statusOptions.find(
                      (option) => option.value === disease.disease_status
                    )}
                    onChange={(selectedOption) =>
                      handleSelectChange(
                        "disease_status",
                        selectedOption ? selectedOption.value : ""
                      )
                    }
                    placeholder="Select Status"
                    //required
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                        borderColor: errors.status ? "#dc3545" : provided.borderColor,
                        boxShadow: errors.status
                          ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                          : provided.boxShadow,
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: () => ({
                        display: "none",
                      }),
                    }}
                    isClearable
                  />
                  {errors.disease_status && (
                    <div className="text-danger d-block mb-2">{errors.disease_status}</div>
                  )}
                </div>
                
              </div>

              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Causes</label>
                  <span style={{ color: "red" }}>*</span>
                  <textarea
                    className="form-control"
                    name="disease_causes"
                    placeholder="Enter Causes"
                    value={disease.disease_causes}
                    onChange={handleChange}
                    rows="3"
                  //required
                  >
                  </textarea>
                  {errors.disease_causes && (
                    <div className="text-danger d-block mb-2">{errors.disease_causes}</div>
                  )}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Prescription Guidelines</label>
                  <span style={{ color: "red" }}>*</span>
                  <textarea
                    className="form-control"
                    name="prescription_guidelines"
                    placeholder="Enter Prescription Guidelines"
                    value={disease.prescription_guidelines}
                    onChange={handleChange}
                    rows="3"
                  //required
                  >
                  </textarea>
                  {errors.prescription_guidelines && (
                    <div className="text-danger d-block mb-2">{errors.prescription_guidelines}</div>
                  )}
                </div>
              </div>


              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Treatment Plan</label>
                  <span style={{ color: "red" }}>*</span>
                  <textarea
                    className="form-control"
                    name="treatment_plan"
                    placeholder="Enter Treatment Plan"
                    value={disease.treatment_plan}
                    onChange={handleChange}
                    rows="3"
                  //required
                  >
                  </textarea>
                  {errors.treatment_plan && (
                    <div className="text-danger d-block mb-2">{errors.treatment_plan}</div>
                  )}
                </div>

                <div className="col-xl-6 mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    name="disease_description"
                    placeholder="Enter Description"
                    value={disease.disease_description}
                    onChange={handleChange}
                    rows="3"
                  ></textarea>
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-primary me-2"
                disabled={loading || fetching}
              >
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">Submitting...</span>
                  </>
                ) : (
                  <>{isEditMode ? "Update Diseases" : "Add Diseases"}</>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDiseases;
